
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'

import { mapState } from 'vuex'
export default {
name: 'user',
props: [],
components: {
XHeader,
Group,
XButton,
XSwitch,
Checklist
},
data () {
return {
title: this.$route.meta.title,
value: ['0'],
isEdit: false,
donateId: '',
btnText: '',
isList: [{key: '1', value: '捐赠'}, {key: '0', value: '不捐赠'}],
tips: '根据《关于做好2015届毕业生离校工作的通知》（西交就（2015）5号）文件精神，学校基金会倡议，毕业生可将校园卡中余额捐赠给学校，以助学校未来发展。卡内余额将在校园卡功能失效一个月后，转到学校教育基金会设立的捐款账户。'
}
},
computed: {
value1 () {
if (this.value[0] === '0') {
return 0
} else {
return 1
}
},
...mapState({
token: state => state.token,
flowId: state => state.flowInfo.flowId,
studentId: state => state.userInfo.id
})
},
created () {
},
mounted () {
this.getDonte()
},
methods: {
back () {
setTimeout(() => {
this.$router.back(-1)
}, 300)
},
change (value, label) {

},

getDonte () {
this.$vux.loading.show({
text: '加载中'
})
let params = {}
params.flowId = this.flowId
params.studentId = this.studentId
this.$api.get('/donation', params, r => {
this.$vux.loading.hide()
if (r.data.length > 0) {
if (r.data[0].will) {
this.value = ['1']
} else {
this.value = ['0']
}
this.isEdit = true
this.donateId = r.data[0].id
this.btnText = '重新提交'
} else {
this.btnText = '提交'
}
},
err => {
this.$vux.toast.text(err.message, 'middle')
})
},

postDonte () {
let params = {}
params.flowId = this.flowId
params.studentId = this.studentId
params.will = this.value1
this.$api.post('/donation', params, r => {
this.$vux.loading.hide()
let msg = params.will ? '余额已捐赠' : '余额未捐赠'
this.$vux.toast.text('提交成功，' + msg, 'middle')
},
err => {
this.$vux.toast.text(err.message, 'middle')
})
},

putDonte () {
let params = {}
params.flowId = this.flowId
params.studentId = this.studentId
params.will = this.value1
params.id = this.donateId
this.$api.put('/donation', params, r => {
this.$vux.loading.hide()
let msg = params.will ? '余额已捐赠' : '余额未捐赠'
this.$vux.toast.text('提交成功，' + msg, 'middle')
},
err => {
this.$vux.toast.text(err.message, 'middle')
})
},

submit () {
if (this.isEdit) {
this.putDonte()
} else {
this.postDonte()
}
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/user/userItem/donate.vue